import type { FunctionComponent, ReactNode } from "react";

type Props = {
  children?: ReactNode;
  isContentLoading: boolean;
};

export const PlusPaywallSuspenseContent: FunctionComponent<Props> = ({
  children,
  isContentLoading,
}) => {
  if (isContentLoading) {
    const promise = new Promise(resolve => resolve(isContentLoading));
    // eslint-disable-next-line write-good-comments/write-good-comments
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw promise;
  } else {
    return children;
  }
};

PlusPaywallSuspenseContent.displayName = "PlusPaywallSuspenseContent";
